<template>
  <div>
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <br>
            <h2>HEQ Loan Comparison</h2>

            <v-text-field
              v-model="loanAmount"
              :rules="loanAmountRules"
              prefix="$"
              type="number"
              label="Loan Amount"
              required
            />

            <v-text-field
              v-model="interestRate"
              :rules="interestRateRules"
              type="number"
              prefix="%"
              label="Interest Rate"
              required
            />
            <v-btn
              class="mr-4"
              @click="submit"
            >
              submit
            </v-btn>
          </v-col>

          <v-card
            v-if="calculated"
            class="mx-auto"
            max-width="600"
            tile
          >
            <v-card-title>
              Your potential savings with Heq Hequity loan
            </v-card-title>
            <v-card-text>
              <br>
              <h1 style="color: green">
                $ {{ typeOneTotalSavings }} - {{ typeThreeTotalSavings }}
              </h1>
              <br>
              <v-divider />
              <br>
              * Low 2% fixed rate
              <br>
              * No monthly payment for the first 5 years
            </v-card-text>
            <v-divider />

            <v-card-actions>
              <v-btn
                text
                color="blue accent-4"
              >
                Learn More
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
        <v-row>
          <v-col>
            <v-card
              v-if="showCards && calculated"
              class="mx-auto"
              max-width="300"
              tile
            >
              <v-card-title><h2>HEQ Type 1</h2></v-card-title>
              <v-card-text>
                Total Loan Amount: {{ heqLoanAmount }}
                <br>
                Term: 30 Years
                <br>
                Monthly Payment: {{ typeOneHeqMonthlyPayment }}
                <br>
                <br>
                Total: {{ Math.round(typeOneHeqMonthlyPayment * 30 * 12) }}
              </v-card-text>

              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Amortization
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              Term
                            </th>
                            <th class="text-left">
                              Principal
                            </th>
                            <th class="text-left">
                              Interest
                            </th>
                            <th class="text-left">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="sheet in amSheet"
                            :key="sheet.name"
                          >
                            <td>{{ sheet.name }}</td>
                            <td>{{ sheet.principal }}</td>
                            <td>{{ sheet.interest }}</td>
                            <td>{{ sheet.total }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              v-if="showCards && calculated"
              class="mx-auto"
              max-width="300"
              tile
            >
              <v-card-title><h2>HEQ Type 2</h2></v-card-title>
              <v-card-text>
                Total Loan Amount: {{ heqLoanAmount }}
                <br>
                Term: 26 Years
                <br>
                Monthly Payment: {{ typeTwoHeqMonthlyPayment }}
                <br>
                <br>
                Total: {{ Math.round(typeTwoHeqMonthlyPayment * 315) }}
              </v-card-text>

              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Amortization
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              Term
                            </th>
                            <th class="text-left">
                              Principal
                            </th>
                            <th class="text-left">
                              Interest
                            </th>
                            <th class="text-left">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="sheet in amSheet"
                            :key="sheet.name"
                          >
                            <td>{{ sheet.name }}</td>
                            <td>{{ sheet.principal }}</td>
                            <td>{{ sheet.interest }}</td>
                            <td>{{ sheet.total }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              v-if="showCards && calculated"
              class="mx-auto"
              max-width="300"
              tile
            >
              <v-card-title><h2>HEQ Type 3</h2></v-card-title>
              <v-card-text>
                Total Loan Amount: {{ heqLoanAmount }}
                <br>
                Term: 30 Years
                <br>
                Monthly Payment: {{ typeThreeHeqMonthlyPayment }}
                <br>
                <br>
                Total: {{ Math.round(typeThreeHeqMonthlyPayment * 25 * 12) }}
              </v-card-text>

              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Amortization
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              Term
                            </th>
                            <th class="text-left">
                              Principal
                            </th>
                            <th class="text-left">
                              Interest
                            </th>
                            <th class="text-left">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="sheet in amSheet"
                            :key="sheet.name"
                          >
                            <td>{{ sheet.name }}</td>
                            <td>{{ sheet.principal }}</td>
                            <td>{{ sheet.interest }}</td>
                            <td>{{ sheet.total }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              v-if="showCards && calculated"
              class="mx-auto"
              max-width="300"
              tile
            >
              <v-card-title>
                <h2>Conventional</h2>
              </v-card-title>
              <v-card-text>
                Total Loan Amount: {{ loanAmount }}
                <br>
                Term: 30 Years
                <br>
                Monthly Payment: {{ typeOneMonthlyPayment }}
                <br>
                <br>
                Total: {{ Math.round(typeOneMonthlyPayment * 30 * 12) }}
              </v-card-text>

              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Amortization
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              Term
                            </th>
                            <th class="text-left">
                              Principal
                            </th>
                            <th class="text-left">
                              Interest
                            </th>
                            <th class="text-left">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="sheet in amSheet"
                            :key="sheet.name"
                          >
                            <td>{{ sheet.name }}</td>
                            <td>{{ sheet.principal }}</td>
                            <td>{{ sheet.interest }}</td>
                            <td>{{ sheet.total }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  import Finance from 'financejs'
  export default {
    name: 'LoanComparisonOld',
    components: {},
    data () {
      return {
        valid: false,
        loanAmount: '',
        heqLoanAmount: '',
        interestRate: 3.5,
        heqInterestRate: 2.0,

        typeOneMonthlyPayment: 0,
        typeOneHeqMonthlyPayment: 0,

        typeTwoMonthlyPayment: 0,
        typeTwoHeqMonthlyPayment: 0,

        typeThreeMonthlyPayment: 0,
        typeThreeHeqMonthlyPayment: 0,
        showCards: true,
        calculated: false,
        amSheet: [{
                    name: '5 Year',
                    principal: 20600,
                    interest: 33200,
                    total: 53800,
                  }, {
                    name: '10 Year',
                    principal: 45100,
                    interest: 62600,
                    total: 107700,
                  },
                  {
                    name: '15 Year',
                    principal: 74300,
                    interest: 87200,
                    total: 161600,
                  },
                  {
                    name: '20 Year',
                    principal: 109100,
                    interest: 106300,
                    total: 215400,
                  },
                  {
                    name: '30 Year',
                    principal: 200000,
                    interest: 123300,
                    total: 323300,
                  }],
        loanAmountRules: [
          v => !!v || 'Loan Amount is required',
          v => v > 0 || 'Loan Amount must be greater than 0',
        ],

        interestRateRules: [
          v => !!v || 'Interest Rate is required',
          v => v > 0 || 'Interest Rate must be greater than 0%',
        ],

        // Rules max 80% loan to value - if they don't meet that, display a message indicating that we dont support that loan to value ratio.
        //

      }
    },
    computed: {
      typeOneTotalSavings () {
        return Math.round(this.typeOneMonthlyPayment * 30 * 12 - this.typeOneHeqMonthlyPayment * 30 * 12)
      },
      typeThreeTotalSavings () {
        return Math.round(this.typeOneMonthlyPayment * 30 * 12 - this.typeThreeHeqMonthlyPayment * 25 * 12)
      },

    },
    methods: {
      submit () {
        const finance = new Finance.Finance()
        if (this.interestRate > 0) {
          this.typeOneMonthlyPayment = finance.AM(this.loanAmount, this.interestRate, 30, 0)
          this.typeTwoMonthlyPayment = finance.AM(this.loanAmount, this.interestRate, 30, 0)
        }

        if (this.heqInterestRate > 0) {
          const requiredDownPayment = this.loanAmount * 0.10
          this.heqLoanAmount = requiredDownPayment + parseInt(this.loanAmount)
          this.typeOneHeqMonthlyPayment = finance.AM(this.heqLoanAmount, this.heqInterestRate, 30, 0)

          // ToDo Figure out how to pay extra here...
          this.typeTwoHeqMonthlyPayment = finance.AM(this.heqLoanAmount, this.heqInterestRate, 315, 1)

          this.typeThreeHeqMonthlyPayment = finance.AM(this.heqLoanAmount, this.heqInterestRate, 25, 0)
        }
        this.amortize(200000, 3.5, 360)

        this.calculated = true
      },
      amortize () {
        const payment = this.pmt(3.5 / 100 / 12, 12 * 30, -200000).toFixed(2)
        console.log(this.computeSchedule(200000, 3.5, 12, 30, payment))
      },
      computeSchedule (loanAmount, interestRate, paymentsPerYear, years, payment) {
        const schedule = []
        let remaining = loanAmount
        const numberOfPayments = paymentsPerYear * years

        for (let i = 0; i <= numberOfPayments; i++) {
          const interest = remaining * (interestRate / 100 / paymentsPerYear)
          const principle = (payment - interest)
          const row = [i, principle > 0 ? (principle < payment ? principle : payment) : 0, interest > 0 ? interest : 0, remaining > 0 ? remaining : 0]
          schedule.push(row)
          remaining -= principle
        }

        return schedule
      },

      pmt (rate, numberPayments, pv) {
        let pvif, pmt

        // eslint-disable-next-line prefer-const
        pvif = Math.pow(1 + rate, numberPayments)
        // eslint-disable-next-line prefer-const
        pmt = rate / (pvif - 1) * -(pv * pvif)

        return pmt
      },
    },
  }
</script>

<style scoped>

</style>
